var _style, _path, _path2, _polygon, _rect, _rect2, _rect3, _rect4, _path3, _path4, _polygon2, _polygon3, _circle;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlapx1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st402{fill:#FFFFFF;stroke:#000000;stroke-width:3.22;stroke-miterlimit:10;}\n\t.st401{fill:#FFFFFF;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st400{fill:#FFFFFF;stroke:#000000;stroke-width:1.07;stroke-miterlimit:10;}\n\t.st399{stroke:#000000;stroke-width:1.07;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st402",
    d: "M70.4,352.8c0.8-13.8,1.9-27.9,3.3-42.7c4.4-45.8,10.8-83.5,15.9-109.2c3.7,0.2,7.2,0.4,10.9,0.5 c3.3,0.1,6.7,0.2,10,0.2c26.1,0.3,52.1-1.6,78.2-1.3c3.3,0,6.7,0.1,10,0.2c4.3,0.1,8.5,0.3,12.8,0.6c-0.2,48.2-0.3,100.7-0.4,151.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st402",
    d: "M212,352.8c-0.2-50.7-0.3-103.2-0.5-151.4c4.5-0.3,9-0.5,13.5-0.6c3.3-0.1,6.7-0.2,10-0.2 c26.8-0.2,53.6,1.8,80.4,1.3c3.3,0,6.7-0.1,10-0.3c2.7-0.1,5.3-0.3,8-0.4c5,25.7,11.4,63.3,15.9,109.2c1.4,14.7,2.5,29,3.3,42.7"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st401",
    points: "334.5,199.9 88.7,199.9 92.9,170.5 330.4,170.5 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 174.5,
    y: 182.2,
    transform: "matrix(2.111690e-02 -0.9998 0.9998 2.111690e-02 2.7768 377.2564)",
    className: "st400",
    width: 39,
    height: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86.3,
    y: 182.2,
    transform: "matrix(2.111690e-02 -0.9998 0.9998 2.111690e-02 -83.6036 289.0528)",
    className: "st400",
    width: 39,
    height: 10
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 224.8,
    y: 167.7,
    transform: "matrix(0.9998 -2.111691e-02 2.111691e-02 0.9998 -3.9013 4.8939)",
    className: "st400",
    width: 10,
    height: 39
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 315.1,
    y: 167.7,
    transform: "matrix(0.9998 -2.111691e-02 2.111691e-02 0.9998 -3.881 6.8022)",
    className: "st400",
    width: 10,
    height: 39
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st400",
    d: "M147.4,204.1c-2.1,23.1-4.2,37.8-6.3,60.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st400",
    d: "M279.8,204.1c2.1,23.1,4.2,35.7,6.3,58.9"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st400",
    points: "325.1,268.3 245.1,268.3 244.9,262.7 324.8,262.7 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st400",
    points: "244.9,274.4 285.2,288 324.8,274.4 325.1,265.2 245.1,265.2 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st399",
    cx: 285,
    cy: 279.7,
    r: 5.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlapx1);
export default __webpack_public_path__ + "static/media/FLAP X 1.ddbf1126a0efa36efc25c3ff93cc25b3.svg";
export { ForwardRef as ReactComponent };